import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/variant-product/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "./Model"
import { useState, useEffect } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

export default function ProductVariant() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Product Variants</h5>
      </div>

      <CrudProvider>
        <ProductVariantTable />
      </CrudProvider>
    </>
  )
}

function ProductVariantTable() {
  const { openDialog, setOpenDialog, setSelectedRow } = useCrudContext()
  const [selectedId, setSelectedId] = useState(null)

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useCustomQuery(
    ["product-variant-detail", selectedId],
    `product-variant/${selectedId}`,
    {
      enabled: !!selectedId,
      refetchOnMount: "always",
    }
  )

  const handleOnEdit = (row) => {
    // set a quick preview row while we fetch details
    setSelectedRow(row)
    setSelectedId(row.id)
    setOpenDialog(true)
  }

  // when detailed response arrives, replace selectedRow with full data
  useEffect(() => {
    if (response && response.data) {
      setSelectedRow(response.data)
    }
  }, [response, setSelectedRow])

  return (
    <>
      <CustomTable
        label="Product Variants"
        columns={columns}
        apiPath="product-variant"
        onEdit={handleOnEdit}
      />

      {openDialog ? (
        <Modal
          isLoading={isLoading}
          onClose={() => {
            setSelectedRow(null)
            setSelectedId(null)
            setOpenDialog(false)
          }}
        />
      ) : null}
    </>
  )
}
